import { useMemo } from 'react';

import { clientConfig } from '@/config/clientConfig';
import { useApi } from '@/shared/api';

export const useFetchFile = () => {
  const api = useApi();

  return useMemo(() => {
    const fetchFile = async (filePath: string) => {
      let fileData;

      if (clientConfig.isExported) {
        const response = await fetch(`${clientConfig.selfUrl}/encrypted-files/${filePath}`);
        fileData = await response.text();
      } else {
        const res = await api.filesGet(filePath, { format: 'text' });
        fileData = res.data;
      }

      return fileData;
    };

    return { fetchFile };
  }, []);
};
